const TechDebtWaterfallChart = (data=[]) => {
  const categories = data.map(d => d.date);
  const debtAdded = data.map(d => d.added || 0);
  const debtResolved = data.map(d => -(d.resolved || 0)); // negative for waterfall effect
  const useDataZoom = data.length > 15;
  const added= '#ffac82';
  const resolved= '#77ed8b';
  return {
    color: [added, resolved],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        return params.map(p => {
          const value = Math.abs(p.value);
          return `${p.marker} ${p.seriesName}: ${value}`;
        }).join('<br/>');
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 35 : 35,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        rotate: 0
      }
    },
    yAxis: {
      type: 'value',
      name: 'Tickets'
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 40
        },
        {
          type: 'slider',
          show: false,
          start: 0,
          end: 40,
          xAxisIndex: 0,
          height: 15,
          bottom: 40
        }
      ]
      : [],
    series: [
      {
        name: 'Debt Added',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: added,  borderRadius: [4, 4, 0, 0] },
        data: debtAdded,
        label: {
          show: true,
          position: 'top',
          formatter: '{c}', // shows count (value)
          color: '#000',     // or any theme-matching color
          fontSize: 12
        }
      },
      {
        name: 'Debt Resolved',
        type: 'bar',
        stack: 'total',
        itemStyle: { color: resolved,  borderRadius: [4, 4, 0, 0] },
        data: debtResolved
      }
    ]
  };
};

export default TechDebtWaterfallChart;
